import 'rxjs/add/observable/of';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import type { Location, RouterActionPush } from '@atlassian/react-resource-router';
import { addSelectedIssueToUrl } from '../../services/routing/selected-issue-url-change';
import {
	openDetailView,
	OPEN_DETAIL_VIEW_DEBOUNCED,
	type OpenDetailViewDebouncedAction,
} from '../../state/actions/detail-view';
import { makeCardKeyFromCardId } from '../../state/selectors/cards';
import type { ActionsObservable, MiddlewareAPI } from '../../state/types';

export const detailViewOpenDebouncedEpic =
	(getLocation: () => Location, push: RouterActionPush) =>
	(action$: ActionsObservable, store: MiddlewareAPI) =>
		action$
			.ofType(OPEN_DETAIL_VIEW_DEBOUNCED)
			.debounceTime(500)
			.mergeMap((action: OpenDetailViewDebouncedAction) => {
				push(
					addSelectedIssueToUrl(
						makeCardKeyFromCardId(store.getState())(action.payload.cardId),
						getLocation(),
					),
				);
				return Observable.of(openDetailView(action.payload.cardId, action.payload.externalAction));
			});
